import { frontendURL } from 'dashboard/helper/URLHelper.js';

import TamCampaignsView from './pages/TamCampaignsView.vue';

// Eltafouk: «حملة رد على تم» — admin-only full-page iframe that embeds the
// platform campaigns dashboard (api.eltafouk.com/app/campaigns). The route is
// gated to administrators via meta.permissions; the in-component admin guard +
// the platform's own server-side Chatwoot Agents-API check are the real
// authority. Non-admins never see the sidebar entry nor pass this route guard.
const meta = {
  permissions: ['administrator'],
};

const tamCampaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/tam-campaigns'),
      name: 'tam_campaigns_index',
      meta,
      component: TamCampaignsView,
    },
  ],
};

export default tamCampaignsRoutes;
